module.exports = __webpack_public_path__ + "static/media/gryphon-house-east-view-cropped.b09e81a6.jpg";